export const SET_CAPTCHA_RESPONSE = 'SET_CAPTCHA_RESPONSE';

export const setCaptchaResponse = response => ({
    type: SET_CAPTCHA_RESPONSE,
    response,
});
